import axios from './axiosInstance';

const getObjectUrlByIdJpeg = (contentId: string): Promise<string | void> => {
  let url = `/content/${contentId}`;
  return axios.get(url, {
    responseType: 'arraybuffer',
    headers: {
      'Accept': 'image/jpeg'
    }
  })
    .then((response) => {
      const blob = new Blob([response.data], {
        type: 'image/jpeg',
      });
      const objectURL = URL.createObjectURL(blob);
      return objectURL;
    })
    .catch((error) => {
      console.log(error);
    });
}

const restrictedContentFunctions = {
  getObjectUrlByIdJpeg,
};

export default restrictedContentFunctions;
